/**
 * Extract a consistent user ID from the MSAL user object
 * @param user - The MSAL user object
 * @returns A string ID that can be used in API calls
 */
export const extractUserId = (
  user?: { localAccountId?: string; homeAccountId?: string } | null
): string => {
  if (!user) return "";

  // Prefer localAccountId, fallback to homeAccountId
  return user.localAccountId || user.homeAccountId?.split(".")[0] || "";
};
